import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询故障日志列表
export const get_accidentLog_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      accident_name: params.accident_name,
      accident_level_id: params.accident_level_id,
      accident_place_id: params.accident_place_id,
      accident_time: params.accident_time,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/projectAccidentLog/list", params)
}
//添加故障日志
export const get_accidentLog_add = (params) => {
  params = {
    row: {
      vin: params.vin,
      accident_name: params.accident_name,
      accident_level_id: params.accident_level_name,
      accident_place_id: params.accident_place_id,
      accident_time: params.accident_time_str,
      car_route: params.car_route,
      detail: params.detail,
      accident_loss: params.accident_loss,
      accident_measures: params.accident_measures,
      subsequent_deal: params.subsequent_deal,
      handler: params.handler,
      other: params.other
    }
  }
  return post_request("/web/projectAccidentLog/add", params)
}
//获取单个故障日志
export const get_accidentLog_one = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/projectAccidentLog/getOne", params)
}
//编辑故障日志
export const get_accidentLog_edit = (params) => {
  params = {
    row: {
      id: params.id,
      vin: params.vin,
      accident_name: params.accident_name,
      accident_level_id: params.accident_level_id,
      accident_place_id: params.accident_place_id,
      accident_time: params.accident_time_str,
      car_route: params.car_route,
      detail: params.detail,
      accident_loss: params.accident_loss,
      accident_measures: params.accident_measures,
      subsequent_deal: params.subsequent_deal,
      handler: params.handler,
      other: params.other
    }
  }
  return post_request("/web/projectAccidentLog/update", params)
}
//删除故障日志
export const get_accidentLog_del = (params) => {
  params = {
    row: {
      id: params
    }
  }
  return post_request("/web/projectAccidentLog/delete", params)
}
//导出一个或多个故障日志
export const get_export_accidentLog = (params) => {
  params = {
    row: {
      id_list: params
    }
  }
  return get_request_export("/web/projectAccidentLog/export", params)
}
//查询事故级别列表
export const get_findAccidentLevelList_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectAccidentLog/findAccidentLevelList", params)
}
//查询事故地点列表
export const get_findPlaceList_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectOperatingLog/cloudPlatformAreaSummaryNoParent", params)
}
//查询车辆列表
export const get_vin_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectAccidentLog/get_vins", params)
}



// WEBPACK FOOTER //
// ./src/api/projectLog/accidentLog.js